import React from 'react';
import { Formik } from 'formik';
import IntegrationsProvider from 'screens/Integrations/context/IntegrationsProvider';

import Provider from '../../../context/Provider';
import BaseAgrianRecommendationIntegration from '../BaseAgrianRecommendationIntegration';
import { INTEGRATIONS } from '../../../../helpers/constants';
import SubmissionSummaryProvider from '../../../../SubmissionSummary/context/SubmissionSummaryProvider';

const AgrianRecommendationParentProvider = () => {
  return (
    <IntegrationsProvider>
      <Provider>
        <Formik initialValues={{}}>
          {() => (
            <SubmissionSummaryProvider
              integrationType={INTEGRATIONS.agrianRecommendation}
            >
              <BaseAgrianRecommendationIntegration />
            </SubmissionSummaryProvider>
          )}
        </Formik>
      </Provider>
    </IntegrationsProvider>
  );
};

export default AgrianRecommendationParentProvider;
